import { RegionDto, UrlKeyDto } from '@trucktrax/trucktrax-ts-common';
import React, { Component } from 'react';

import { MessagesTabs } from '../../../../constants/appConstants';
import { MessageTabs } from '../../../../constants/messagingConstants';
import { DataItem } from '../AutoCompleteWithChip';
import { ConversationMessagesDto, ConversationToMessagesDto, MessageCenterInfo } from '../index.d';
import styles from './LeftSidebar.module.css';
import MessageList from './LeftSidebar/MessageList';
import NewMessage from './LeftSidebar/NewMessage';
import Tabs from './LeftSidebar/Tabs';
import { DriverDetail } from '../../../../store/selectors/messageSelectors';
import { updateToFieldValue } from '../../../../store/actions/messageActions';

class LeftSidebar extends Component<LeftSidebarProps> {
  tabBasedContent = () => {
    // new message
    if (this.props.currentTab === MessageTabs.New) {
      return (
        <NewMessage
          driverList={this.props.driverList}
          messageCenter={this.props.messageCenter}
          onToFieldChange={this.props.onToFieldChange}
          onCurrentRecipientSearchTextChange={this.props.onCurrentRecipientSearchTextChange}
          onMessageFieldChange={this.props.onMessageFieldChange}
          onSubmit={this.props.onSubmit}
          delayDriverFocus={this.props.delayDriverFocus}
          selectedProductLine={this.props.selectedProductLine}
          currentRegion={this.props.currentRegion as RegionDto}
        />
      );
      // inbox or sent
    }
    if (this.props.currentTab === MessageTabs.Inbox) {
      const messages = this.props.allMessages;
      return (
        <MessageList
          messages={messages}
          currentRegion={this.props.currentRegion}
          currentTab={this.props.currentTab}
          onMarkUnread={this.props.onMarkUnread}
          onItemClicked={this.props.onItemClicked}
          selectedMessage={this.props.selectedMessage}
          driverList={this.props.driverList}
          selectedProductLine={this.props.selectedProductLine}
          onTabChange={this.props.onTabChange}
        />
      );
    }
    return <div />;
  };

  render() {
    return (
      <div className={styles.leftSidebar}>
        <Tabs
          onTabChange={this.props.onTabChange}
          currentTab={this.props.currentTab}
          hasUnreadMessages={this.props.hasUnreadMessages}
        />
        {this.tabBasedContent()}
      </div>
    );
  }
}

export interface LeftSidebarProps {
  onTabChange: (value: MessagesTabs, selectedItems?: DataItem[]) => void;
  currentTab: MessageTabs;
  hasUnreadMessages: boolean;
  onSubmit: (
    messageCenter: MessageCenterInfo,
    messageId: number | null,
    callback?: () => void,
  ) => void;
  allMessages: ConversationToMessagesDto[];
  currentRegion: UrlKeyDto;
  selectedMessage?: ConversationMessagesDto;
  delayDriverFocus?: boolean;
  driverList: DriverDetail[];
  messageCenter: MessageCenterInfo;
  onToFieldChange: typeof updateToFieldValue;
  onCurrentRecipientSearchTextChange: (newSearchText: string) => void;
  onMessageFieldChange: (message: string) => void;
  onItemClicked: (selectedMessage: ConversationMessagesDto) => void;
  selectedProductLine?: string;
  onMarkUnread: (selectedMessage: ConversationMessagesDto) => void;
}

export default LeftSidebar;
